import { useContext, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import SeleccionContext from "../../../../context/Seleccion/SeleccionContext";
import { IPersonaInhabilitada } from "../../../../interfaces/ISeleccion";

interface IModalRestaurarInhabilitada {
  title: string;
  message: string;
  onChangeBack?: Function;
  buttonBack?: string;
  list?: string[];
  listRefresh: Function;
}

const ModalRestaurarInhabilitada = (props: IModalRestaurarInhabilitada) => {
  const { title, message, onChangeBack, buttonBack, list, listRefresh } = props;
  const {
    token,
    getToken,
    listaPersonasInhabilitadas,
    postDeshacerExclusion,
  } = useContext(SeleccionContext);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleClickDeshacerExclusion = async () => {
    if (isLoading) return;
    if (!token || !list) return;
    // Se muestra el estado de carga antes de la llamada: además de dar feedback,
    // oculta la tabla mientras `listRefresh` la actualiza, evitando el parpadeo
    // de las filas al desaparecer justo antes de cerrar el modal.
    setIsLoading(true);
    try {
      getToken();
      const arrayList = listaPersonasInhabilitadas
        .filter(({ excPerId }: IPersonaInhabilitada) =>
          list.includes(excPerId)
        )
        .map(({ personaId, excPerId }: IPersonaInhabilitada) => ({
          personaId,
          excPerId,
        }));
      await postDeshacerExclusion({ token, candidates: arrayList });
      await listRefresh();
      handleClickCloseModal();
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleClickCloseModal = () => {
    if (isLoading) return;
    typeof onChangeBack == "function" && onChangeBack();
  };

  return (
    <div className="modal-container-seleccion">
      <div className="modal-content-seleccion w-70">
        <div className="modal-title">
          <span>{title}</span>
        </div>

        {isLoading ? (
          <div
            className="modal-message"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 14,
              padding: "26px 0",
            }}
          >
            <CircularProgress size={36} />
            <label>Revirtiendo inhabilitación…</label>
          </div>
        ) : (
          <>
            <div className="modal-message">
              <label>{message}</label>
            </div>

            {list && (
              <section className="content-table-restaurar">
                <table className="table-restaurar w-90">
                  <thead className="thead-table-restaurar">
                    <tr className="tr-table-restaurar">
                      <th className="td-table-restaurar">Nombre</th>
                      <th className="td-table-restaurar">DNI</th>
                      <th className="td-table-restaurar">Tipo</th>
                      <th className="td-table-restaurar">Destino</th>
                    </tr>
                  </thead>
                  <tbody className="tbody-table-restaurar">
                    {list.map((excPerId: string) =>
                      listaPersonasInhabilitadas
                        .filter(
                          (item: IPersonaInhabilitada) =>
                            item.excPerId === excPerId
                        )
                        .map((item: IPersonaInhabilitada) => (
                          <tr
                            className="tr-table-restaurar"
                            key={item.excPerId}
                          >
                            <td className="td-table-restaurar">
                              {item.nombre}
                            </td>
                            <td className="td-table-restaurar">{item.dni}</td>
                            <td className="td-table-restaurar">{item.tipo}</td>
                            <td className="td-table-restaurar">
                              Candidatos habilitados
                            </td>
                          </tr>
                        ))
                    )}
                  </tbody>
                </table>
              </section>
            )}

            <div className="modal-message">
              <label>
                Al confirmar, los candidatos quedarán disponible para
                participar en procesos.
              </label>
            </div>

            <div className="modal-message">
              <label>Para continuar presione Aceptar</label>
            </div>
          </>
        )}

        <div className="modal-button-content center">
          <button
            className={`modal-button cancel`}
            onClick={handleClickCloseModal}
            disabled={isLoading}
          >
            {buttonBack ? buttonBack : "Cancelar"}
          </button>
          <button
            className={`modal-button confirm`}
            onClick={handleClickDeshacerExclusion}
            disabled={isLoading}
          >
            {isLoading ? (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <CircularProgress size={15} color="inherit" />
                Procesando…
              </span>
            ) : buttonBack ? (
              buttonBack
            ) : (
              "Confirmar"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalRestaurarInhabilitada;
